import { Image, Text } from '@atoms/index';
import texts from '@components/ReferAndEarn/en.json';
import { brandName } from '@helpers/constants';
import { getNumberWithComma, replaceKeysWithValues } from '@helpers/miscelleanous';

const userRewards = [
    {
        image: '/images/refer-and-earn/reward-two-people.svg',
        alt: 'two-users-logo',
        amount: process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT * 2,
        primaryText: texts?.BeConnectorEarn,
        secondaryText: replaceKeysWithValues(texts?.forNReferrals, {
            '{n}': '2',
        }),
    },
    {
        image: '/images/refer-and-earn/reward-five-people.svg',
        alt: 'five-users-logo',
        amount: process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT * 5,
        primaryText: texts?.BeInfluencerEarn,
        secondaryText: replaceKeysWithValues(texts?.forNReferrals, {
            '{n}': '5',
        }),
    },
    {
        image: '/images/refer-and-earn/reward-ten-people.svg',
        alt: 'ten-users-logo',
        amount: process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT * 10,
        primaryText: texts?.BeTrailblazerEarn,
        secondaryText: replaceKeysWithValues(texts?.forNReferrals, {
            '{n}': '10',
        }),
    },
];

const Rewards = () => {
    return (
        <div className="px-4 pt-8 pb-16 md:pt-16 md:pb-[100px] flex flex-col gap-6 md:mx-4 lg:mx-0">
            <div className="flex flex-col gap-3 items-center">
                <div className="flex flex-col h4-semibold md:h3-semibold items-center">
                    <Text
                        content={texts?.ReferMoreEarnMore}
                        className="text-primary-600"
                    />
                    <Text
                        content={texts?.NoCapsJustCash}
                        className="text-secondary-500"
                    />
                </div>
                <Text
                    content={replaceKeysWithValues(
                        texts?.EnjoyRewardsEachTime,
                        {
                            '{brandName}': brandName,
                        }
                    )}
                    className="p4-regular text-gray-500 text-center"
                />
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-center justify-center">
                {userRewards.map((item, index) => {
                    return (
                        <div
                            className="p-4 md:py-6 flex flex-row md:flex-col gap-4 md:gap-3 items-center rounded-xl shadow-card w-full md:w-[220px]"
                            key={index}
                        >
                            <div className="w-12 h-12 md:w-16 md:h-16 p-3 md:p-4 rounded-full bg-secondary-100">
                                <Image
                                    src={item.image}
                                    className="w-full h-full"
                                    alt={item.alt}
                                />
                            </div>
                            <div className="flex flex-col md:items-center">
                                <Text
                                    content={item.primaryText}
                                    className="p5-regular text-gray-500"
                                    isInnerHtml
                                />
                                <div className="flex gap-0.5">
                                    <Text
                                        content={'₹'}
                                        className="h6-semibold bg-blue-gradient bg-clip-text text-transparent mt-1.5"
                                    />
                                    <Text
                                        content={getNumberWithComma(
                                            parseInt(item.amount)
                                        )}
                                        className="h3-semibold md:h1-semibold bg-blue-gradient bg-clip-text text-transparent"
                                    />
                                </div>
                                <Text
                                    content={item.secondaryText}
                                    className="p5-regular text-gray-500"
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Rewards;
